module.exports = __webpack_public_path__ + "img/2.5155e264.jpg";